import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  container: css`
    padding-block: 0;
    padding-inline: 16px;
  `,

  // Tail (хвостик)
  tailContainer: css`
    margin-block-end: 8px;
  `,
  tail: css`
    inline-size: 50px;
    block-size: 8px;
    opacity: 0;
    clip-path: polygon(50% 100%, 0% 0%, 100% 0%);
    transition: opacity 0.2s;
  `,
  tailVisible: css`
    opacity: 1;
  `,

  // Bubble
  bubble: css`
    background-color: var(--colorScheme-bgMinor, #f5f4f2);
    border-radius: 32px;
    padding-block: 12px;
    padding-inline: 16px;
    min-block-size: 64px;
    overflow: hidden;
  `,

  // Иконка
  icon: css`
    inline-size: 40px;
    block-size: 40px;
  `,

  // Заголовок
  title: css`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    padding-inline-end: 8px;
  `,

  // Кнопка - светлее плашки (полупрозрачный белый поверх темного фона)
  button: css`
    background-color: var(--colorScheme-controlMinor, rgba(245, 244, 242, 0.1));
    border-radius: 32px !important;
    padding-block: 4px;
    padding-inline: 14px;
    block-size: 28px;
    min-block-size: 28px !important;
    min-height: 28px !important;
    white-space: nowrap;
  `,

  buttonText: css`
    color: var(--colorScheme-text, #000000);
  `,
}
